import { useLang } from '@/app/utils/useLang';
import CommonProducts from '../components/common-products';

const SmartGeneration: React.FC = () => {
    const { t } = useLang('landingPage.smart_generation');

    const items = [
        {
            img: '',
            label: t('item1_title'),
            productId: '8243170214042',
            variantId: '44934331236506',
            learnMore: 'https://ca.ecoflow.com/products/smart-generator-4000-dual-fuel?variant=44934331236506',
        },
        {
            img: '',
            label: t('item2_title'),
            productId: '7287920001178',
            variantId: '42092770263194',
            learnMore: 'https://ca.ecoflow.com/products/400w-portable-solar-panel?variant=42092770263194',
        },
        {
            img: '',
            label: t('item3_title'),
            productId: '15030544531827',
            variantId: '52317425009011',
            learnMore: 'https://ca.ecoflow.com/products/125w-bifacial-modular-solar-panel?variant=52317425009011',
        },
    ];

    return <CommonProducts items={items} title={t('title')} />;
};

export default SmartGeneration;
